// extracted by mini-css-extract-plugin
module.exports = {"wrap":"HeaderIconButton_wrap__1uoGe","text":"HeaderIconButton_text__HeLBo","icon-wrap":"HeaderIconButton_icon-wrap__GvxBj"};